<div class="main-disclaimer-image"><img src="assets/disclaimer.png" alt="Disclaimer Image" class="disclaimer-image"></div>
<h1 mat-dialog-title oneDialogTitle>Confidential Information</h1>
<div mat-dialog-content oneDialogContent class="disclaimer-container">
  <div class="disclaimer-data">
    <p>I acknowledge that I am bound by confidentiality obligations improsed through my employment or contractual agreement with Roche in connection with my access to confidential information, including QN/SBN/MN/SN/SNR and its contents.</p>
    <p>By entering QN/SBN/MN/SN/SNR, I confirm that I understand that my activities within QN/SBN/MN/SN/SNR may be monitored consistent with local law, and all contents and passwords are confidential information, and that unauthorized disclouser or use of such confidential information may result in disciplinary action including termination of my employment or services and/or legal action based on local law.</p>
  </div>
</div>
<div mat-dialog-actions oneDialogActions class="disclaimer-action">
  <div class="ad-button-row">
    <div>
      <button color="primary" mat-flat-button class="disclaimer-apply" (click)="isAccepted()" [mat-dialog-close]="false">I accept</button>
      <button mat-stroked-button one-secondary-button class="disclaimer-logoff" (click)="isLogoff()">
        Log off
      </button>
    </div>
  </div>
</div>